import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import UIIcon from 'UIComponents/icon/UIIcon';
import { isPrerenderAgent } from '../../../../utils/prerender';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useState } from 'react';
import styled, { css, theme, mediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavGroup = styled.div.withConfig({
  displayName: "FooterNavGroup__NavGroup",
  componentId: "sc-11r4vqc-0"
})(["", " & a.footer-link{font-size:14px;}"], mediaQuery('tablet', css(["border-bottom:1px solid ", ";"], theme.colors.EERIE)));
const NavGroupHeading = styled.button.withConfig({
  displayName: "FooterNavGroup__NavGroupHeading",
  componentId: "sc-11r4vqc-1"
})(["position:relative;width:100%;text-align:center;padding:24px;font-size:18px;background:none;border:none;color:", ";", ""], theme.colors.OLAF, mediaQuery('notTablet', css(["text-align:left;padding:0;margin-bottom:16px;cursor:default;"])));
const FooterNavGroup = ({
  headingText,
  children
}) => {
  const {
    isNotTablet
  } = useMediaQuery();
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/_jsxs(NavGroup, {
    children: [/*#__PURE__*/_jsxs(NavGroupHeading, {
      "aria-checked": isOpen,
      onClick: () => setIsOpen(!isOpen),
      role: "switch",
      children: [/*#__PURE__*/_jsx("span", {
        children: headingText
      }), !isNotTablet && /*#__PURE__*/_jsx(UIIcon, {
        name: isOpen ? 'up' : 'down',
        style: {
          marginLeft: '15px'
        }
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: isOpen || isNotTablet || isPrerenderAgent(),
      children: children
    })]
  });
};
export default FooterNavGroup;